import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next"
import { colors, css, fonts, glyphs } from "../../../Styles"
import { ButtonList, CoreWidget } from "../..";
import { AttentionTypes, ListStyle_Types } from "../../../Definitions";

// TODO
import StartSectionModal from "../Modals/startSection";
import CalibrateSectionModal from "../Modals/calibrateSection";
import EmptySectionModal from "../Modals/emptySection";
import { useSection } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useSections";
import { useAppSelector } from "../../../Store";
import { Graph_QL } from "../../../Services";
import { useParams } from "react-router";
import { useTerminals } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useTerminals";
import { useSystem } from "../../../Services/Agrisys_GqlDataCaller/SystemCalls/useSystem";

interface systemControls_props {
  system: number
}
/**
 * SystemControls
 * @returns A widget with btns to controle the system.
 */
export default function SystemControls({system}:systemControls_props) {
  const {t} = useTranslation(); 
  const [isOn, setIsOn] = useState<boolean>(true)
  const [message, setMessage] = useState<JSX.Element>(<></>)
  const [startSectionModal, setStartSectionModal] = useState<boolean>(false)
  const [calibrateSectionModal, setCalibrateSectionModal] = useState<boolean>(false)
  const [emptySectionModal, setEmptySectionModal] = useState<boolean>(false)
  
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);

  const { emergencyStopSystem } = useSystem(connection)
  const { call: getTerminals } = useTerminals(connection)

  useEffect(() => {
    getTerminals({fetchAmount: 10})
  }, [])
  
  const {systemId: urlSystemId} = useParams(); // TODO routing changes in order to get a correct system info
  const systemId = urlSystemId ? +urlSystemId : system;

  const {startFeedingBySystem} = useSection(connection)

  const successMessage = <p style={{textAlign: "center", ...fonts.fontSize4, ...fonts.paragraph, color: colors.systemGreen}}>{t("success", {defaultValue: "success"})}</p>

  const handleOnClick = () => {
    setMessage(successMessage)
    startFeedingBySystem(systemId);
    setTimeout(() => {
      setMessage(<></>);
    }, 2000);
  }

  const systemPower = isOn
  ? {
      systemPower: t(`systemControls.states.${AttentionTypes.good}`, {defaultValue: "system running"}),
      statusColor: colors.systemGreen,
      buttonText: t("systemControls.general.emergencyStop", {defaultValue: "Emergency Stop"}),
      buttonEnhancer: glyphs.OnOff({ size: "30px", rotate: 90 }),
    }
  : {
      systemPower: t(`systemControls.states.${AttentionTypes.neutral}`, {defaultValue: "system off"}),
      statusColor: colors.systemRed,
      buttonText: t("systemControls.general.startSystem", {defaultValue: "start system"}),
      buttonEnhancer: glyphs.OnOff({ size: "30px"}),
    };

  return( <>
    <CoreWidget
      header={<p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>{t("systemControls.general.systemControls", {defaultValue: "System Controls"})}</p>}
      bgColor={colors.greyPrimary}
      width="320px"
      height="360px"
      content={
        <div style={{display: "flex", flexDirection: "column", gap: "10px", justifyContent: "space-between", marginBottom: "20px"}}>
          <div style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "5px"}}>
              <p style={{...fonts.fontSize4, ...fonts.paragraph, color: colors.greyLightTertiary}}>{`${t("systemControls.general.systemState", {defaultValue: "System state"})}:`}</p>
              <div style={{...fonts.fontSize4, ...fonts.header, backgroundColor: systemPower.statusColor, color: colors.greyLightTertiary, padding: "4px 5px", borderRadius: "6px", width: "fit-content"}}>{ systemPower.systemPower }</div>
          </div>
          {message}
          <ButtonList
            contents={[
              t("systemControls.general.startSection", {defaultValue: "Start Section"}),
              t("systemControls.general.calibrateSection", {defaultValue: "Calibrate Section"}),
              t("systemControls.general.emptySection", {defaultValue: "Empty Section"}),
              systemPower.buttonText,
            ]}
            startEnhancers={[
              glyphs.Start({ size: "30px" }),
              glyphs.Calibrate({ size: "30px" }),
              glyphs.Empty({ size: "30px" }),
              systemPower.buttonEnhancer
            ]}
            overrides={{
              baseButton: {backgroundColor: colors.greySecondary},
              hoverStyles: {backgroundColor: colors.greyDarkSecondary},
              startEnhancerStyles: {...css.button_PositionStartEnhancerStart},
              disabledStyles: {opacity: "0.3"}
            }}
            listOverrides={{
              listStyle: ListStyle_Types.vertical
            }}
            disabled={[isOn? false : true, isOn? false : true, isOn? false : true, false]}
            onClick={(i) => {
              if (i === 0) {setStartSectionModal(true)}
              if (i === 1) {setCalibrateSectionModal(true)}
              if (i === 2) {setEmptySectionModal(true)}
              if (i === 3) {
                if (isOn) {
                  if (window.confirm(t("systemControls.general.confirmStop", {defaultValue: "Would you like to proceed the emergency stop of the system?"}))) { setIsOn(false);  emergencyStopSystem(systemId) }
                } else {
                  setIsOn(true)
                }
              } 
            }}
          />
        </div>
      }
    />

    <StartSectionModal isModalOpen={!!startSectionModal} onClose={() => setStartSectionModal(false)} system={systemId}/>
    <CalibrateSectionModal isModalOpen={!!calibrateSectionModal} onClose={() => setCalibrateSectionModal(false)} system={systemId}/>
    <EmptySectionModal isModalOpen={!!emptySectionModal} onClose={() => setEmptySectionModal(false)} system={systemId}/>
  </> )
}